import { render } from "./FooterLinksList.vue?vue&type=template&id=4c33726b&scoped=true"
import script from "./FooterLinksList.vue?vue&type=script&lang=js"
export * from "./FooterLinksList.vue?vue&type=script&lang=js"

import "./FooterLinksList.vue?vue&type=style&index=0&id=4c33726b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c33726b"]])

export default __exports__